module.exports = __webpack_public_path__ + "static/media/train-card5.f385e6b3.jpg";